module.exports = __webpack_public_path__ + "img/preview-photo-review-SECOND_TYPE.25c529b6.png";